import { ConfigService } from "./app/shell/config.service";

const configService = new ConfigService();

if (configService.config.cdnHost) {
  __webpack_require__.p = configService.config.cdnHost;
}
